module.exports = __webpack_public_path__ + "img/emamHossein.b699ee57.png";